<script>
export default {
  props: ['stableData'],
  computed: {
    u_level () {
      if (this.stableData && this.stableData.ua_rms > 1000 && this.stableData.ub_rms > 1000 && this.stableData.uc_rms > 1000) {
        return true
      } else {
        return false
      }
    },
    i_level () {
      if (this.stableData && this.stableData.ia_rms > 1000 && this.stableData.ib_rms > 1000 && this.stableData.ic_rms > 1000) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<template>
<div class="pg">
  <!--      有效值-->
  <div class="dataItems">
    <div class="title">有效值</div>
    <div class="dataItem">
      <div class="dataName">
        <div class="dataTitle"></div>
        <div class="dataNvItem">{{u_level?"Ua(kV)":"Ua(V)"}}</div>
        <div class="dataNvItem">{{u_level?"Ub(kV)":"Ub(V)"}}</div>
        <div class="dataNvItem">{{u_level?"Uc(kV)":"Uc(V)"}}</div>
        <div class="dataNvItem">{{u_level?"Uab(kV)":"Uab(V)"}}</div>
        <div class="dataNvItem">{{u_level?"Ubc(kV)":"Ubc(V)"}}</div>
        <div class="dataNvItem">{{u_level?"Uca(kV)":"Uca(V)"}}</div>
      </div>
      <div class="dataValue">
        <div class="dataTitle">
          <div>全波</div>
          <div>有效值</div>
        </div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ua_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ub_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uc_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uab_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ubc_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uca_rms : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
      </div>
      <div class="dataValue" style="border-right: 1px solid black;">
        <div class="dataTitle">
          <div>基波</div>
          <div>有效值</div>
        </div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ua_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ub_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uc_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uab_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ubc_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.uca_rms_fund : 0) / (u_level ? 1000 : 1)).toFixed(2) }}</div>
      </div>
      <div class="dataName">
        <div class="dataTitle"></div>
        <div class="dataNvItem">{{i_level?"Ia(kA)":"Ia(A)"}}</div>
        <div class="dataNvItem">{{i_level?"Ib(kA)":"Ib(A)"}}</div>
        <div class="dataNvItem">{{i_level?"Ic(kA)":"Ic(A)"}}</div>
        <div class="dataNvItem">{{i_level?"In(kA)":"In(A)"}}</div>
        <div class="dataNvItem">{{(this.stableData && stableData.i_laek_rms>1000)?"ILeak(A)":"ILeak(mA)"}}</div>
      </div>
      <div class="dataValue">
        <div class="dataTitle">
          <div>全波</div>
          <div>有效值</div>
        </div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ia_rms : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ib_rms : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ic_rms : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.in_rms : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.i_laek_rms : 0) / ((this.stableData && stableData.i_laek_rms>1000) ? 1000 : 1)).toFixed(2) }}</div>
      </div>
      <div class="dataValue">
        <div class="dataTitle">
          <div>基波</div>
          <div>有效值</div>
        </div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ia_rms_fund : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ib_rms_fund : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.ic_rms_fund : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">{{ (Number(stableData ? stableData.in_rms_fund : 0) / (i_level ? 1000 : 1)).toFixed(2) }}</div>
        <div class="dataNvItem">NA</div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
</style>



// WEBPACK FOOTER //
// src/pages/Stable/Rms/Rms.vue